import { render, staticRenderFns } from "./MaterialList.vue?vue&type=template&id=6d923671&scoped=true&"
import script from "./MaterialList.vue?vue&type=script&lang=js&"
export * from "./MaterialList.vue?vue&type=script&lang=js&"
import style0 from "./MaterialList.vue?vue&type=style&index=0&id=6d923671&prod&lang=scss&"
import style1 from "./MaterialList.vue?vue&type=style&index=1&id=6d923671&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d923671",
  null
  
)

export default component.exports